import React from 'react'
import styled from 'styled-components'
import {PressableProps} from './PressableProps'

const StyledPressable = styled.div`
  display: contents;
  :hover {
    cursor: pointer;
  }
`

export default function Pressable({children, ...props}: PressableProps) {
  return <StyledPressable {...props}>{children}</StyledPressable>
}
